// ** Redux Imports
import { configureStore, combineReducers } from '@reduxjs/toolkit'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

// Import reducers
import authReducer from './slices/authSlice'
import casesReducer from './slices/casesSlice'
import usersReducer from './slices/usersSlice'
import productsReducer from './slices/productsSlice'
import patientsReducer from './slices/patientsSlice'
import notificationsReducer from './slices/notificationsSlice'
import couponsReducer from './slices/couponsSlice'
import chatReducer from './slices/chatSlice'
import attachmentsReducer from './slices/attachmentsSlice'
import settingsReducer from './slices/settingsSlice'
import cartReducer from './slices/cartSlice'
import shopReducer from './slices/shopSlice'
import dashboardReducer from './slices/dashboardSlice'
import ordersReducer from './slices/orderSlice'
import profileReducer from './slices/profileSlice'
import notificationPreferencesReducer from './slices/notificationPreferencesSlice'
import reportsReducer from './slices/reportsSlice'

// Existing reducers
import layoutReducer from './layout'
import navbarReducer from './navbar'

// Persist configuration
const persistConfig = {
  key: 'bds-root',
  storage,
  whitelist: ['auth', 'cart', 'settings'], // Only persist these reducers
  blacklist: ['cases', 'users', 'notifications'] // Don't persist these for security
}

// Combine all reducers
const rootReducer = combineReducers({
  // New slices
  auth: authReducer,
  cases: casesReducer,
  users: usersReducer,
  products: productsReducer,
  patients: patientsReducer,
  notifications: notificationsReducer,
  coupons: couponsReducer,
  chat: chatReducer,
  attachments: attachmentsReducer,
  settings: settingsReducer,
  cart: cartReducer,
  shop: shopReducer,
  dashboard: dashboardReducer,
  orders: ordersReducer,
  profile: profileReducer,
  notificationPreferences: notificationPreferencesReducer,
  reports: reportsReducer,

  // Existing reducers
  layout: layoutReducer,
  navbar: navbarReducer
})

// Create persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer)

// Configure store
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
        ignoredPaths: ['register']
      }
    }),
  devTools: process.env.NODE_ENV !== 'production'
})

// Create persistor
export const persistor = persistStore(store)

// Export types for TypeScript projects
// export type RootState = ReturnType<typeof store.getState>
// export type AppDispatch = typeof store.dispatch

export default store
